<template>
    <section id="configuration" class="c-account__section">
        <h2 class="c-account__title">
            {{ _t("Configuration du compte") }}
        </h2>
        <form class="o-form o-grid -x-sm -y-sm" @submit.prevent="submitForm">
            <div class="o-grid-12">
                <div v-if="confirm.message" class="o-form__confirmation"
                    :class="{ '-error': confirm.state == 'error', '-success': confirm.state == 'success' }">
                    <p class="o-form__confirmation__text">{{ confirm.message }}</p>
                </div>
            </div>
            <div class="o-grid-12">
                <div class="o-text">
                    <h5 class="">{{ _t("Titulaire du compte") }}</h5>
                </div>
            </div>
            <div class="o-form__group o-grid-6">
                <label class="o-label" for="prenom">{{ _t("Prénom") }}</label>
                <input class="o-input" id="prenom" type="text" :class="{'-input-filled' : user.firstname }" v-model.trim="user.firstname" required />
            </div>

            <div class="o-form__group o-grid-6">
                <label class="o-label" for="nom">{{ _t("Nom") }}</label>
                <input id="nom" class="o-input" type="text" :class="{'-input-filled' : user.lastname }" v-model.trim="user.lastname" required />
            </div>

            <PhoneElement
                :label="_t('Téléphone')"
                name="phone" 
                allow-incomplete unmask
                rules="required"
                :replace-classes="{
                    ElementLayout:{
                        container: {
                            'vf-element-layout': ['o-form__group', 'o-grid-6']
                        },
                        outerWrapper: {
                            'vf-element-layout-outer-wrapper': ''
                        },
                        innerContainer: {
                            'vf-layout-inner-container': '',
                            'vf-col-12': ''
                        },
                    },
                    PhoneElement:{
                        input: {
                            'vf-input-field': 'o-input',
                        }
                    },
                    ElementLabel:{
                        container:{
                            'vf-label': 'o-label',

                        }
                    }
                }"
                :default="user.phone"
                :placeholder="user.phone"
                :floating="false"
                @change="user.phone = $event"
                />
            <div class="o-form__group o-grid-6">
                <label class="o-label" for="email">{{ _t("Email") }}</label>
                <input id="email" class="o-input" type="email" :class="{'-input-filled' : user.email }" v-model.trim="user.email" required />
            </div>
            <div class="o-grid-12">
                <div class="o-text">
                    <h5 class="">{{ _t("Modifier mon mot de passe") }}</h5>
                </div>
            </div>
            <div class="o-form__group o-grid-6">
                <label class="o-label" for="password">{{ _t("Nouveau mot de passe") }}</label>
                <input id="password" class="o-input" type="password" v-model.trim="user.password"
                :class="{'-input-filled' : user.password }" autocomplete="new-password" />
            </div>
            <div class="o-form__group o-grid-6">
                <label class="o-label" for="confirmPassword">{{ _t("Confirmer le mot de passe") }}</label>
                <input id="confirmPassword" class="o-input" type="password" v-model.trim="user.confirm"
                :class="{'-input-filled' : user.confirm }" autocomplete="new-password" />
            </div>
            <div class="o-grid-12">
                <div class="o-form__button">
                    <button class="o-button o-button-cart" type="submit">
                        <span class="o-button__text">{{ _t("Sauvegarder") }}</span>
                        <span class="sr-only">{{ _t("Sauvegarder") }}</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#save"></use>
                        </svg>  
                    </button>
                </div>
            </div>
        </form>
    </section>
</template>
<script>
import axios from 'axios'
import { Vueform, useVueform } from '@vueform/vueform'

export default {
    name: 'DashboardConfig',
    mixins: [Vueform],
    setup: useVueform,
    data: function () {
        return {
            editConf: {
                lastname: false,
                firstname: false,
                email: false,
                password: false,
                address: false,
                phone: false
            },
            user: {
                address: {}
            },
            confirm: {
                state: '',
                message: ''
            },
        }
    },
    methods: {
        getUser() {
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/stereostore/v1/checklogin', { params })
                .then(response => {
                    if (response.data.success == false) {
                        location.href = '/connexion/'
                    }
                    this.user = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        triggerEdit(field) {
            this.editConf[field] = !this.editConf[field]
        },
        submitForm() {
            if (this.user.password != this.user.confirm) {
                this.confirm = {
                    state: 'error',
                    message: 'Les mots de passe ne correspondent pas'
                }
                return
            }

            let data = {
                'first_name': this.user.firstname,
                'last_name': this.user.lastname,
                'email': this.user.email,
                'meta': {
                    'address': this.user.address,
                    'phone': this.user.phone
                }
            }
            //Set axios headers
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.post('/wp-json/wp/v2/users/' + this.user.ID, data)
                .then(response => {
                    this.user = {
                        ID: response.data.id,
                        firstname: response.data.first_name,
                        lastname: response.data.last_name,
                        email: response.data.email,
                        address: response.data.meta.address,
                        phone: response.data.meta.phone
                    }
                    this.editConf = {
                        lastname: false,
                        firstname: false,
                        email: false,
                        password: false,
                        address: false,
                    }

                    this.confirm = {
                        state: 'success',
                        message: 'Vos informations ont bien été mises à jour'
                    }
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                })
        },
        setPlace(place) {
            this.user.address = place
        },
    },
    mounted() {
        this.getUser()
    },
}
</script>